export const genInfoKeys = {
  image: null,
  gender: "male",
  firstName: "",
  lastName: "",
  fatherName: "",
  emailAddress: "",
  password: "user123",
  bloodGroup: "",
  qualification: "",
  dob: "",
  maritalStatus: "",
  religion: "",  
  contact_number: ""
};

export const identities = {
  nationalId: "",
  machineCode: "",
  employee_code: "",
  EOBI: "",
  passportNo: "",
  NTN: "",
};

export const address = {
  country: "",
  city: "",
  zipCode: "",
  nationality: "",
  permanent_address: "",
  temporary_address: "",
};
// export const contact = {
//   home_phone: "",
//   mobile: "",
//   emergency_contactNo: "",
//   emergency_contact_name: "",
// };
export const contract = {
  hire_date: null,
  joining_date: null,
  status: "",
  employee_type: "",
  probation_months: "",
  shift: "",
  contract_start_date: null,
  contract_end_date: null,
  // probation_start_date: null,
  p_confirmation_date: null,
  location: "",
  designation: "",
  department: "",
  sub_department: "",
  reporting_to: "",
};
export const eligibility = {
  medical: "noteligible",
  travel: "noteligible",
  bouns: "noteligible",
};

export const salary = {
  salary_type: "",
  day_calculation: "",
  monthly_salary: "",
  fixed_Days: "",
  perday_salary: "",
  perhour_salary: "",
  total_ammount: "",
  paid_type: "",
  paid_ammount: "",
  advance_payment: "",
  hourly_rate: "",
  salary_additional: [],
  allowance: "",
  deduction: "",
  contribution: "",
  overAll_salary: ""
};
export const dependents = {
  relationship_type: "",
  emergency_contact: "",
  emergency_firstName: "",
  emergency_lastName: "",
  remarks: "",
};

export const attendance = {
  rule_applied: true,
  hours_in_day: true,
  early_out: true,
  late_arrival: true,
  overtime_policy: true,
  missing_attendance: true,
  leave_ristrictions: true,
  attendance_web: false,
  attendance_machine: false,
  frontSideImg: null,
  backSideImg: null
};

export const payment = {
  paymeny_type: '',
  bank_name: '',
  account_title: '',
  account_number: '',
  ibn_number: '',
}

